import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'react-photo-view/dist/react-photo-view.css';
import {PhotoProvider} from 'react-photo-view'
import AuthProvider from './context/AuthProvider/AuthProvider';

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
    <PhotoProvider>
    <App />
    </PhotoProvider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

